import { useMemo, useState } from 'react';

import { CatalogStereo, ProductView } from '@lemoncloud/codes-goods-api';

type SortType = 'newest' | 'oldest';

export const useProductFiltering = (products: ProductView[]) => {
    const [sortType, setSortType] = useState<SortType>('newest');
    const [stereo, setStereo] = useState<CatalogStereo | 'all'>('all');

    const stereos = useMemo(() => {
        return [...new Set(products.map(product => product.catalog$?.stereo).filter(stereo => stereo !== undefined))];
    }, [products]);

    const sortedProducts = useMemo(() => {
        if (!products) {
            return [];
        }

        const sorted = [...products];
        return sorted.sort((a, b) => {
            return sortType === 'newest'
                ? (b.createdAt as number) - (a.createdAt as number)
                : (a.createdAt as number) - (b.createdAt as number);
        });
    }, [products, sortType]);

    const filteredProducts = useMemo(() => {
        return sortedProducts.filter(p => (stereo === 'all' ? true : p.catalog$?.stereo === stereo));
    }, [sortedProducts, stereo]);

    const filteredStereos = useMemo(() => {
        return stereos.filter(stereoType => {
            return filteredProducts.some(product => product.catalog$?.stereo === stereoType);
        });
    }, [stereos, filteredProducts]);

    return {
        sortType,
        setSortType,
        stereo,
        setStereo,
        stereos,
        filteredProducts,
        filteredStereos,
    };
};
